// import {useState } from 'react';

import { useTranslation } from 'react-i18next';

import useAxiosPrivate from './useAxiosPrivate';
import useUtilities from './useUtilities';
export const errorsFromBackendToUniqueString = (errors) => {
    const errorMessages = {};

    errors.forEach((error) => {
        const { msg, param } = error;

        if (!errorMessages[msg]) {
            errorMessages[msg] = new Set();
        }

        errorMessages[msg].add(param);
    });

    return Object.entries(errorMessages)
        .map(([msg, params]) => `${msg}: ${Array.from(params).join(', ')}`)
        .join('; ');
};
const STANDARD_ERROR_MESSAGE = 'Une erreur s\'est produite lors du traitement de la demande.';
const usePostRequest = () => {
    // * if there is some received Data to store after the post
    // const [data, setData] = useState(null);
    const { setBackdropOpen, setOpenSnackBar, setSnackBarMessage,setIsSnackBarError } = useUtilities();
    const axiosPrivate = useAxiosPrivate();
    const {i18n}=useTranslation();

    const postData = async ({url,payload,propertyName,}) => {
        setBackdropOpen(true);
        let responseStatus;
        let tempData;
        try {
            // payload is an object {key:value}
            const response = await axiosPrivate.post(url,payload);
            console.log(response);
            if(propertyName)
                tempData = response?.data?.[propertyName];
            else tempData = response?.data;

            // setData(tempData);
            setBackdropOpen(false);
            setSnackBarMessage(i18n.t(response?.data?.message));
            setIsSnackBarError(false);
            setOpenSnackBar(true);
            responseStatus = response?.status;
        } catch (error) {
            console.log(error.response?.status,error.response?.data.error);
            responseStatus = error.response?.status;
            setBackdropOpen(false);
            //* to make sure it's a string
            if(error.response?.data.error){
                setSnackBarMessage(i18n.t(error.response?.data.error) ?? i18n.t(STANDARD_ERROR_MESSAGE));
            }
            if(error.response?.data?.errors){
                setSnackBarMessage(errorsFromBackendToUniqueString(i18n.t(error.response?.data.errors)) ?? i18n.t(STANDARD_ERROR_MESSAGE));
            }
            setIsSnackBarError(true);
            setOpenSnackBar(true);
        }
        // setBackdropOpen(false);
        return {data:tempData,responseStatus};
    };
    const postDataSilently = async ({url,payload,propertyName,}) => {
        // setBackdropOpen(true);
        let responseStatus;
        let tempData;
        try {
            // payload is an object {key:value}
            const response = await axiosPrivate.post(url,payload);
            console.log(response);
            if(propertyName)
                tempData = response?.data?.[propertyName];
            else tempData = response?.data;

            // setSnackBarMessage(response?.data?.message);
            // setOpenSnackBar(true);
            responseStatus = response?.status;
        } catch (error) {
            console.log(error.response?.status,error.response?.data.error);
            responseStatus = error.response?.status;
            //* to make sure it's a string
            // if(error.response?.data.error){
            //     setSnackBarMessage(error.response?.data.error ?? STANDARD_ERROR_MESSAGE);
            // }
            // if(error.response?.data?.errors){
            //     setSnackBarMessage(errorsFromBackendToUniqueString(error.response?.data.errors) ?? STANDARD_ERROR_MESSAGE);
            // }
            // setOpenSnackBar(true);
        }
        // setBackdropOpen(false);
        return {data:tempData,responseStatus};
    };

    return {postData, postDataSilently};
};

export default usePostRequest;